import { REPORT_OPTION_COVER_LETTER, REPORT_OPTION_SUMMARY, RESULT_FAIL, RESULT_NONE, RESULT_PASS } from '../constants';
/**
 * Fixed list, unlike the File type filter which derives its options from the rows actually
 * present (E2E-24). Result is a closed enum plus the NULL case, so offering only the values
 * currently in the data would make the filter flicker as rows are edited.
 */
export function buildResultOptions(translateFn) {
    return [
        { value: RESULT_PASS, label: translateFn('result.pass') },
        { value: RESULT_FAIL, label: translateFn('result.fail') },
        { value: RESULT_NONE, label: translateFn('result.none') }
    ];
}
/** Also fixed — the two booleans are the whole domain. */
export function buildReportOptionsOptions(translateFn) {
    return [
        { value: REPORT_OPTION_SUMMARY, label: translateFn('report_options.summary_label') },
        { value: REPORT_OPTION_COVER_LETTER, label: translateFn('report_options.cover_letter_label') }
    ];
}
